/**
 * @file AgreeCookie
 */

'use strict';

/**
 * @classname AgreeCookie
 * @classdesc Cookie同意
 */
export default class AgreeCookie {
	/**
	 * @constructor
	 * @param {jQuery} $e - body
	 */
	constructor($e, controller) {
		console.log(`AgreeCookie.constructor`);
		this._$e = $e;
		const ls = window.localStorage.getItem('agree') || null;
		if (!ls) {
			console.log('localstrageなし');
			this.createCookieDom();
		}
	}


	/**
	 * Cookie同意DOM作成
	 *
	 * @memberof AddBtn
	 * @return {undefined}
	 */
	createCookieDom() {
		console.log(`AgreeCookie.createCookieDom`);
		const html = `
<div id="agree-cookie">
	<button id="close-agree-cookie" class="close-cookie">&times;</button>
	<p>
		本ウェブサイトでは、お客様の利便性の向上、本ウェブサイトの品質向上・維持のため、Cookie（クッキー）情報を利用しています。<br>
		お客様は、ご利用端末のブラウザの設定によりクッキーを無効にして本ウェブサイトを利用いただくことはできますが、無効にした場合、本ウェブサイトの一部の機能が制限され、サービスを受けられない可能性がございます。<br>
		詳細については、当社の<a class="read-cookie" href="${window.const.STATIC_URL.COOKIE_POLICY}">クッキーポリシー</a>をご覧ください。<br>
	</p>
</div>`;
		this._$e.append(html);
		const $agreeCookie = $('#agree-cookie');
		const height = $agreeCookie.outerHeight();
		console.log(height);
		$agreeCookie.css('bottom', `-${height}px`);
		$agreeCookie.animate({ 'bottom': '0' }, 500);
		$('.close-cookie').on('click', () => {
			$agreeCookie.animate({ 'bottom': `-${height}px` }, 500);
			window.localStorage.setItem('agree', 'y');
		});
		$('.read-cookie').on('click', (e) => {
			e.preventDefault();
			const $e = $(e.currentTarget);
			window.localStorage.setItem('agree', 'y');
			const link = $e.attr('href');
			setTimeout(() => {
				location.href = link;
			}, 200);
		})

	};
}
